import { combineReducers } from 'redux'
import UserReducer from './UserReducer'
import PlayerApiReducer from './PlayerApiReducer'
import ProgrammeSearchReducer from './ProgrammeSearchReducer'
import StopResumeReducer from './StopResumeReducer'
import GuidanceAcceptanceReducer from './GuidanceAcceptanceReducer'
import PinAcceptanceReducer from './PinAcceptanceReducer'
import LoginStatusReducer from './LoginStatusReducer'
import PlayeErrorReducer from './PlayerErrorReducer'
import CookiePolicyAcceptanceReducer from './CookiePolicyAcceptanceReducer'
import PlayerHeaderReducer from './PlayerHeaderReducer'
import ModalReducer from './ModalReducer'
import ConcurrentStreamReducer from './ConcurrentStreamReducer'
import LiveChannelsReducer from './LiveChannels'
import FeatureFlagsReducer from './FeatureFlagsReducer'
import EpisodeReducer from './EpisodeReducer'

const rootReducer = combineReducers({
  user: UserReducer,
  playerApiCache: PlayerApiReducer,
  programmeSearch: ProgrammeSearchReducer,
  stopResume: StopResumeReducer,
  guidanceAcceptance: GuidanceAcceptanceReducer,
  pinAcceptance: PinAcceptanceReducer,
  playerError: PlayeErrorReducer,
  loginStatus: LoginStatusReducer,
  cookiePolicyAcceptance: CookiePolicyAcceptanceReducer,
  playerHeader: PlayerHeaderReducer,
  modal: ModalReducer,
  concurrentStream: ConcurrentStreamReducer,
  liveChannels: LiveChannelsReducer,
  featureFlags: FeatureFlagsReducer,
  episode: EpisodeReducer,
})

export default rootReducer
